module.exports = __webpack_public_path__ + "img/banner.dd5eb100.png";